import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import BaseMixer from "@/router/views/BaseMixer";
import { PACycleSaveModel } from "@/store/models/cycle/paCycleSaveDTO";
let CycleInfoComponent = /** @class */ (() => {
    var _a;
    let CycleInfoComponent = class CycleInfoComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Cycle Info";
        }
        created() { }
        destroyed() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof PACycleSaveModel !== "undefined" && PACycleSaveModel) === "function" ? _a : Object)
    ], CycleInfoComponent.prototype, "paCycleSave", void 0);
    CycleInfoComponent = __decorate([
        Component({
            name: "CycleInfoComponent",
        })
    ], CycleInfoComponent);
    return CycleInfoComponent;
})();
export default CycleInfoComponent;
